import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons';

import useFullscreen from 'hooks/useFullscreen';

import Button from 'components/Button';

const StyledButton = styled(Button)`
  width: 2.8vw;
  height: 2.8vw;
  background: #FFFFFF;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const iconStyles = {
  fontSize: '1.4vw',
  color: '#42B0D5',
  transform: 'translate(0, 2px)',
};

const FullscreenSwitcherButton = ({ ...props }) => {
  const [visible, setVisible] = useState(true);
  const { isFullscreen, toggle: toggleFullscreen } = useFullscreen();

  useEffect(() => {
    let mouseMoved = false;
    const interval = setInterval(() => {
      if (!mouseMoved) {
        setVisible(false);
        document.body.style.cursor = 'none';
      } else {
        mouseMoved = false;
      }
    }, 1000);

    const onMouseMove = () => {
      mouseMoved = true;
      setVisible(true);
      document.body.style.cursor = 'unset';
    };

    document.addEventListener("mouseenter", onMouseMove);
    document.addEventListener('mousemove', onMouseMove);

    return () => {
      clearInterval(interval);
      document.body.style.cursor = 'unset';

      document.removeEventListener('mouseenter', onMouseMove);
      document.removeEventListener('mousemove', onMouseMove);
    };
  }, []);

  return visible
    ? (
      <StyledButton
        {...props}
        type="text"
        onClick={toggleFullscreen}
        icon={
          !isFullscreen
            ? <FullscreenOutlined style={iconStyles} />
            : <FullscreenExitOutlined style={iconStyles} />
        }
      />
    ) : null;
};

export default FullscreenSwitcherButton;
